/** Most companies one People or Companies search can target, from a list's
 *  companies or a bulk paste of domains / company LinkedIn URLs. */
export const MAX_SEARCH_COMPANIES = 2500;
